import { useState } from "react";
import { cn } from "@/lib/utils";
import { FunctionList } from "./FunctionList";
import { ReferenceTree } from "./ReferenceTree";
import type { FormulaContextSpec } from "../context";

interface PaletteProps {
  context: FormulaContextSpec;
  onInsert: (snippet: string) => void;
}

type Tab = "references" | "functions";

export function Palette({ context, onInsert }: PaletteProps) {
  const [tab, setTab] = useState<Tab>("references");
  return (
    <div className="flex flex-col h-full min-h-0 border-l border-olive-6 bg-olive-1">
      <div className="flex flex-none">
        <TabButton active={tab === "references"} onClick={() => setTab("references")}>
          References
        </TabButton>
        <TabButton active={tab === "functions"} onClick={() => setTab("functions")}>
          Functions
        </TabButton>
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto">
        {tab === "references" ? (
          <ReferenceTree context={context} onInsert={onInsert} />
        ) : (
          <FunctionList context={context} onInsert={onInsert} />
        )}
      </div>
    </div>
  );
}

function TabButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex-1 px-3 py-2 text-sm border-b",
        active
          ? "border-[var(--farmless-green)] text-olive-12 font-medium"
          : "border-transparent text-olive-10 hover:text-olive-11",
      )}
    >
      {children}
    </button>
  );
}
